import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "icon_table_sound_on",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20.01",
  height: "17.847",
  viewBox: "0 0 20.01 17.847"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_557",
  "data-name": "Path 557",
  d: "M-2269.844-3141.921l-3.461-3.24v-11.014l3.461-2.592c1.508-1.06,2.473.156,2.473,1.944v12.958c0,1.325-.621,2.351-1.488,2.351A1.583,1.583,0,0,1-2269.844-3141.921Zm7.438-1.218a12.036,12.036,0,0,0,2.3-7.07,11.153,11.153,0,0,0-2.292-7.611l1.778-1.541a13.319,13.319,0,0,1,2.866,9.228,14.254,14.254,0,0,1-2.858,8.516Zm-3.745-2.6a8,8,0,0,0,1.627-4.844,8.015,8.015,0,0,0-1.553-4.745l1.9-1.385a10.347,10.347,0,0,1,2.006,6.13,10.343,10.343,0,0,1-2.1,6.258Zm-9.13.576c-1.365,0-2.473-1.451-2.473-3.239v-4.536c0-1.789,1.108-3.239,2.473-3.239h1.482v11.014Z",
  transform: "translate(2277.754 3159.361)",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  id: "icon_table_sound_off",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "22.21",
  viewBox: "0 0 20 22.21"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  id: "Subtraction_41",
  "data-name": "Subtraction 41",
  d: "M-2269.363-3140.219a1.581,1.581,0,0,1-.985-.408l-1.872-1.752,4.343-5.977v5.787C-2267.876-3141.229-2268.515-3140.219-2269.363-3140.219Zm8.242-.1h0l-1.792-1.521a12.032,12.032,0,0,0,2.3-7.067,11.627,11.627,0,0,0-1.8-6.968l1.249-1.719-.271-.2.3-.263a13.311,13.311,0,0,1,2.866,9.223,14.248,14.248,0,0,1-2.857,8.511Zm-3.656-2.706h0l-1.879-1.412a8,8,0,0,0,1.626-4.841,7.983,7.983,0,0,0-.386-2.46l1.618-2.227a10.249,10.249,0,0,1,1.122,4.687,10.334,10.334,0,0,1-2.1,6.253Zm-10.071-.838h-.935c-1.363,0-2.471-1.452-2.471-3.237v-4.533c0-1.785,1.109-3.237,2.471-3.237h1.481v10.256l-.546.751Zm1.042-1.433v-9.574l3.459-2.591a1.866,1.866,0,0,1,1.05-.4c.85,0,1.421.94,1.421,2.338v2.061l-5.928,8.159Z",
  transform: "translate(2278.254 3161.481)",
  fill: "#fff"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  id: "Rectangle_567",
  "data-name": "Rectangle 567",
  width: "26",
  height: "2",
  rx: "1",
  transform: "matrix(0.588, -0.809, 0.809, 0.588, 2.957, 21.034)",
  fill: "#fff"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOn)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_7))
}